import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Row, Col, Spinner } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import IngresaCuenta from '~/components/IngresaCuenta';
import Login from '~/Usuario/Login';
import { Global } from '~/App';
import PortalCompacto from '~/Compact/PortalCompacto';
import API from '~/API';

function getEffectiveQueryParams(props) {
  if (props && typeof props.wixLocation === 'string' && props.wixLocation) return props.wixLocation;
  if (window.location.search && window.location.search.length > 1) return window.location.search;
  if (props && props.location && props.location.search && props.location.search.length > 1) return props.location.search;
  try {
    if (window.top !== window && window.top.location.search && window.top.location.search.length > 1) {
      return window.top.location.search;
    }
  } catch (_) {}
  return "";
}

class Home extends Component {
  componentWillMount() {
    const queryParams = getEffectiveQueryParams(this.props);
    if (queryParams) {
      this.QueryStringRedirect(queryParams, this.props);
    } else {
      this.Redirect(this.props);
    }
  }

  componentWillReceiveProps(props) {
    const prevParams = getEffectiveQueryParams(this.props);
    const nextParams = getEffectiveQueryParams(props);
    if (nextParams && (!prevParams || nextParams !== prevParams)) {
      this.QueryStringRedirect(nextParams, props);
    } else {
      this.Redirect(props);
    }
  }

  QueryStringRedirect(queryParams, props) {
    try {
      if (!queryParams) return;
      const cleanParams = queryParams.startsWith('?') ? queryParams : (queryParams.indexOf('?') >= 0 ? queryParams.substring(queryParams.indexOf('?')) : `?${queryParams}`);
      const params = new URLSearchParams(cleanParams);

      const seccion = (params.get('seccion') || '').toLowerCase();
      const ordendecompra = params.get('ordendecompra');
      const suscripcion = params.get('suscripcion');
      const error = params.get('error');
      const usuario = params.get('usuario');
      const token = params.get('token');
      const empresa = params.get('empresa');
      const servicio = params.get('servicio') || params.get('idServicio');
      const documento = params.get('documento');

      const authToken = params.get('authToken');

      // Si viene authToken (sesión de usuario) y no está en API.Cookie, hidratarlo
      if (authToken && !API.Cookie) {
        API.SetHeaderBearer(authToken).then(() => {
          if (Global.cargarUsuarioSesion) {
            Global.cargarUsuarioSesion();
          }
        });
      }

      // Limpiar query params de window.location para que volver al home no atrape al usuario
      if (window.history && window.history.replaceState && window.location.search) {
        try {
          const cleanUrl = window.location.pathname + (window.location.hash || '');
          window.history.replaceState({}, document.title, cleanUrl);
        } catch (_) {}
      }

      if (ordendecompra) {
        props.history.replace(`/ordendecompra/${ordendecompra}`);
        return;
      }
      if (suscripcion) {
        props.history.replace({
          pathname: `/suscripcion/${suscripcion}`,
          state: { empresa: empresa || '', servicio: servicio || '' }
        });
        return;
      }
      if (error) {
        props.history.replace(`/error/${error}`);
        return;
      }
      if (seccion === 'recuperar' || (usuario && token)) {
        props.history.replace({
          pathname: '/recuperar',
          state: { usuario: usuario || '', token: token || '' }
        });
        return;
      }
      if (seccion === 'registrate' || seccion === 'registro') {
        props.history.replace('/registrate');
        return;
      }

      // 1. Redirección hacia Paga Tu Cuenta (sin reinyectar search en el hash)
      if (seccion === 'paga' || (empresa && (servicio || documento || token))) {
        const payload = {
          empresa: empresa || '',
          servicio: servicio || '',
          documento: documento || null,
          token: token || null,
          captcha: params.get('captcha') || null,
          comuna: params.get('comuna') || '',
          calle: params.get('calle') || '',
          noCasa: params.get('noCasa') || '',
          noDpto: params.get('noDpto') || ''
        };
        props.history.replace({
          pathname: '/paga',
          state: payload
        });
        return;
      }

      // 2. Redirección hacia Sucursal Virtual (solo si el usuario ya está cargado)
      if (seccion === 'sucursal' || seccion === 'admin' || seccion === 'administra') {
        if (props.Usuario) {
          props.history.replace('/sucursal');
        }
        return;
      }

      // 3. Redirección estándar si hay usuario autenticado cargado
      this.Redirect(props);
    } catch (err) {
      console.warn("Error en QueryStringRedirect:", err);
    }
  }

  Redirect(props) {
    if (props.Usuario && (!Global.isModoCompact || !Global.isModoCompact())) {
      props.history.replace("/sucursal");
    }
  }

  render() {
    if (Global.isModoCompact && Global.isModoCompact()) {
      return (
        <PortalCompacto
          {...this.props}
          vista={Global.vista}
          urlDestino={Global.urlDestino}
        />
      );
    }

    if (API.Cookie || (getEffectiveQueryParams(this.props) || '').indexOf('seccion=sucursal') >= 0) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center py-5 my-5 text-center" style={{ minHeight: '300px' }}>
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <div className="mt-3 text-muted font-weight-bold">Ingresando a la Sucursal Virtual...</div>
        </div>
      );
    }

    const isAnonBlocked = Global.isAnonBlocked();

    return (
      <Card>
        <CardHeader className="titulo-modal">Sucursal Virtual</CardHeader>
        <CardBody className="cuerpo-modal">
          <Row>
            <Col sm={isAnonBlocked ? { size: 6, offset: 3 } : 6} className={isAnonBlocked ? "" : "bordeIzquierdoSimple"}>
              <h4>Clientes Registrados</h4>
              <h4 className="text-muted"><small>Ingrese con su usuario y contraseña</small></h4>
              <br />
              <Login />
            </Col>
            {!isAnonBlocked && (
              <Col sm={6} className="bordeDerecho">
                <h4 className="paga-tu-cuenta"><span>Paga tu Cuenta</span></h4>
                <h4 className="text-muted ingrese-datos-cuenta"><small><span>Ingrese los datos de su cuenta</span></small></h4>
                <br />
                <IngresaCuenta {...this.props} />
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
    );
  }
}

export default withRouter(Home);
